import { parseCustomProps } from './parseCustomProps';

export const normalizeProductShelfData = ({ slotData, componentData, mediaCollectionIndex = 0 }) => {
  if (slotData?.slot) {
    const { slot } = slotData;
    const mediaCollections = slot.mediaCollections || [];
    const fallbackMediaCollection = mediaCollections[0] || null;
    const mediaCollection = mediaCollections[mediaCollectionIndex] || fallbackMediaCollection;
    const media = mediaCollection?.media?.[0];

    // mediaCollection.customProps only supplies theme; everything else comes from media.customProps
    const collectionCustomProps = parseCustomProps(mediaCollection?.customProps);
    const customProps = parseCustomProps(media?.customProps);
    return {
      source: 'slot',
      id: mediaCollection.id,
      componentName: 'ProductShelf',
      title: mediaCollection.title,
      sortBy: customProps.sortBy || null,
      sortOrderOptions: customProps.sortOrderOptions || null,
      theme: mediaCollection?.theme || collectionCustomProps.theme || customProps.theme || null,
      publishDate: customProps.publishDate || null,
      productShelfData: {
        navParam: customProps.productShelfData?.navParam || null,
        skus: customProps.productShelfData?.skus || null
      }
    };
  }

  if (componentData?.component) {
    const { component } = componentData;
    return {
      source: 'component',
      id: component.id,
      componentName: component.componentName,
      title: component.title,
      sortBy: component.sortBy,
      sortOrderOptions: component.sortOrderOptions,
      theme: component.theme,
      publishDate: component.publishDate || null,
      productShelfData: {
        navParam: component.productShelfData?.navParam || null,
        skus: component.productShelfData?.skus || null
      }
    };
  }

  return null;
};
